/** Short random ids for records. Letters, digits, `_` and `-` only, so they are safe in CSV, URLs and QR codes. */

const ID_PATTERN = /^[A-Za-z0-9_-]{1,40}$/;
const ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789";

export const isValidId = (s: unknown): s is string => typeof s === "string" && ID_PATTERN.test(s);

/** e.g. `g_k3j9x2abq`. Uses the platform's secure random source. */
export function newId(prefix: string): string {
  const bytes = new Uint8Array(9);
  globalThis.crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < bytes.length; i++) out += ALPHABET[bytes[i] % ALPHABET.length];
  return `${prefix}_${out}`;
}
